<template>
    <div style="width: 100%;">
        <div v-if="showPassword" class="input-group-hide-pass">
            <input type="text" v-model="password" placeholder="Пароль" key="password" class="input-hide-pass"
                :class="{ 'error': hasError.message }" />
            <button type="button" class="eye-button" @click="toggleShow">
                <img src="~@/assets/img/eye-open.svg" alt="show">
            </button>
        </div>
        <div v-else class="input-group-hide-pass">
            <input type="password" v-model="password" placeholder="Пароль" key="password" class="input-hide-pass"
                :class="{ 'error': hasError }">
            <button type="button" class="eye-button" @click="toggleShow">
                <img src="~@/assets/img/eye-close.svg" alt="hide">
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        hasError: {}
    },
    data: () => {
        return {
            password: "",
            showPassword: false,
        };
    },
    watch: {
        password: function () {
            this.$emit('setPass', this.password)
        },
    },
    methods: {
        toggleShow() {
            this.showPassword = !this.showPassword;
        },
    }
}
</script>
<style scoped lang="scss">
.input-group-hide-pass {
    position: relative;
    display: flex;
    width: 100%;

    .input-hide-pass {
        position: relative;
        width: 100%;
        padding: 14px;
        text-align: center;
        border-radius: 8px;
        border: 1px solid #22B491;
        outline: none;
        background-color: transparent;
        font-family: Gilroy;
        font-style: normal;
        font-size: 16px;
        line-height: 19px;
    }

    .input-hide-pass::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #bdbdbd;
        opacity: 1;
        /* Firefox */
    }

    .input-hide-pass:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #bdbdbd;
    }

    .input-hide-pass::-ms-input-placeholder {
        /* Microsoft Edge */
        color: #bdbdbd;
    }

    .input-hide-pass.error {
        border: 1px solid #CF2F38;
    }

    .eye-button {
        position: absolute;
        top: 0;
        left: 0;
        margin: 0;
        padding: 0 12px;
        width: auto;
        background-color: transparent;
    }

    .eye-button:hover {
        position: absolute;
        top: 0;
        left: 0;
        margin: 0;
        padding: 0 12px;
        background-color: transparent;
    }

    .eye-button:focus {
        border: none;
        outline: none;
    }
}



@media screen and (max-width: 725px) {
    .input-group-hide-pass {
        .input-hide-pass {
            display: flex;
            text-align: center;
            width: 100%;
            padding: 14px;
            font-size: 16px;
            font-family: Gilroy;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            border-radius: 8px;
            border: 1px solid #22B491;
            outline: none;
            box-shadow: none;
            -webkit-appearance: none;
        }
    }
}
</style>